import apiClient from '../utils/apiClient';

/**
 * #133517 — Tài khoản nhà cung cấp AI + cấu hình giọng đọc cho trợ lý hướng dẫn game.
 * Mọi cửa đều chỉ ADMIN gọi được (máy chủ gắn RolesGuard + @Roles(ADMIN)).
 */
export const aiProviderAccountAPI = {
  list: async () => {
    return await apiClient.get({ url: '/ai-provider-accounts' });
  },

  create: async (data) => {
    return await apiClient.post({ url: '/ai-provider-accounts', data });
  },

  update: async (id, data) => {
    return await apiClient.put({ url: `/ai-provider-accounts/${id}`, data });
  },

  remove: async (id) => {
    return await apiClient.delete({ url: `/ai-provider-accounts/${id}` });
  },

  reorder: async (provider, orderedIds) => {
    return await apiClient.post({
      url: '/ai-provider-accounts/reorder',
      data: { provider, ordered_ids: orderedIds },
    });
  },

  getTtsSettings: async () => {
    return await apiClient.get({ url: '/ai-provider-accounts/game-voice-tts' });
  },

  saveTtsSettings: async (data) => {
    return await apiClient.put({ url: '/ai-provider-accounts/game-voice-tts', data });
  },
};
